import './components/sliders'
import './components/select'
import './components/account'
import './components/corrects'
import './components/progress'
import './components/sites-tabs'
import './components/login'
import './components/modal-service'
import './components/validate'
